import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "purchase-invoice-container" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "error-alert",
  role: "alert"
}
const _hoisted_4 = { class: "error-message" }
const _hoisted_5 = {
  key: 2,
  class: "success-alert",
  role: "status"
}
const _hoisted_6 = { class: "success-message" }
const _hoisted_7 = {
  key: 4,
  class: "submitting-overlay"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InvoiceDetails = _resolveComponent("InvoiceDetails")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("p", null, "Loading page...", -1)
        ]))]))
      : _createCommentVNode("", true),
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _cache[2] || (_cache[2] = _createElementVNode("span", { class: "error-icon" }, "⚠️", -1)),
          _createElementVNode("span", _hoisted_4, [
            _cache[1] || (_cache[1] = _createElementVNode("strong", null, "Error:", -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.error), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.successMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _cache[3] || (_cache[3] = _createElementVNode("span", { class: "success-icon" }, "✅", -1)),
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.successMessage), 1)
        ]))
      : (_ctx.invoice)
        ? (_openBlock(), _createBlock(_component_InvoiceDetails, {
            key: 3,
            invoice: _ctx.invoice,
            accounts: _ctx.accounts,
            dimensions: _ctx.dimensions,
            vatCodes: _ctx.vatCodes,
            onApprove: _ctx.approve,
            onReject: _ctx.reject,
            onUpdate: _ctx.update,
            onUpdateInvoice: _ctx.handleInvoiceUpdate
          }, null, 8, ["invoice", "accounts", "dimensions", "vatCodes", "onApprove", "onReject", "onUpdate", "onUpdateInvoice"]))
        : _createCommentVNode("", true),
    (_ctx.submitting)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[4] || (_cache[4] = [
          _createElementVNode("div", { class: "submitting-overlay-content" }, [
            _createElementVNode("span", { class: "spinner" }),
            _createElementVNode("span", null, "Processing...")
          ], -1)
        ]))]))
      : _createCommentVNode("", true)
  ]))
}